import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import { BrowserRouter, Route, Routes } from "react-router";
import { Provider } from "react-redux";
import { store, persistore } from "./store/index.tsx";
import { PersistGate } from "redux-persist/integration/react";
import "./utils/i18n/index.ts";
import ErrorBoundary from "./utils/ErrorBoundary.tsx";
import ErrorPage from "./pages/ErrorPage.tsx";
import PageLoader from "./dev/components/PageLoader.tsx";
import * as Sentry from "@sentry/react";
import { SENTRY_DSN } from "./utils/env.ts";
import { HelmetProvider } from "react-helmet-async";
import { BaseIdentityProvider } from "@base-identity/react";
import { identityBaseUrl, identityClient, identityPublishableKey } from "@/auth/identity";
import { IdentityBootstrap } from "@/auth/IdentityBootstrap";

Sentry.init({
  dsn: SENTRY_DSN,
  sendDefaultPii: true,
});

createRoot(document.getElementById("root")!).render(
  <Provider store={store}>
    <BaseIdentityProvider baseUrl={identityBaseUrl} publishableKey={identityPublishableKey} client={identityClient}>
      <PersistGate loading={<PageLoader text="טוען את הנתונים אנא המתן" />} persistor={persistore}>
      <StrictMode>
        <HelmetProvider>
          <BrowserRouter>
            <IdentityBootstrap>
            <ErrorBoundary fallback={<ErrorPage />}>
              <Routes>
                <Route path="*" element={<App />} />
              </Routes>
            </ErrorBoundary>
            </IdentityBootstrap>
          </BrowserRouter>
        </HelmetProvider>
      </StrictMode>
      </PersistGate>
    </BaseIdentityProvider>
  </Provider>
);
